import AnalyticsDecorate from '../../analytics/decorate';
import History from '../../core/history/history';
import DesignFacade from '../../facade/design/design';
import EditorFacade from '../../facade/editor/editor';
import ProjectFacade from '../../facade/project/project';
import RestrictDecorate from '../../facade/restrictions/decorate';
import { instance as CompanyFactory } from '../../factory/company';
import UserInfoFactory from '../../factory/user-info';
import WorkflowFactory from '../../factory/workflow';

import FileView from './contents/file/view';
import createLayoutButton from './contents/layout-button/layout-button';
import VersionsView from './contents/versions/view';
import { initTopBar } from './init-top-bar';
import SizeView from './size';
import statusNotification from './status';

const maxAllowedChars = 255;

module.exports = AnalyticsDecorate(require('./analytics/view'),
  RestrictDecorate(require('./restrict/view'), Backbone.View.extend({
    events: {
      'click .menus button[data-action="save"]': 'saveEvent',
      'click .menus button[data-action="undo"]': 'undoEvent',
      'click .menus button[data-action="redo"]': 'redoEvent',
      'click .menus button[data-action="back-create"]': 'exitEvent',
      'click .back-button-container > button[data-action="exit"]': 'exitEvent',
      'click .logo-icon': 'exitEvent',

      'click .menus button[data-action="versions"]': 'versionsEvent',
      'click .menus button[data-action="resize"]': 'resizeEvent',
      'click .options > button[data-action]': 'defaultActionEvent',
      'click .options > button[data-action="order-print"]': 'orderPrintEvent',

      'mouseenter .menus .desygner-clear-button, .options .desygner-clear-button': 'hideToolTips',
      'click .menus .desygner-clear-button': 'hideToolTips',
      'click .options .desygner-clear-button': 'hideToolTips',
      'click .menus [data-action="file"]': 'setPossibleActions',

      'keydown [data-value="project-name"] span': 'preNameChangeEvent',
      'blur [data-value="project-name"] span': 'nameInputBlurEvent',
      'click [data-value="project-name"] span': 'nameInputClickEvent'
    },

    setPossibleActions: function () {
      this.canSave();
      this.canTranslate();
    },

    canSave: function (event) {
      const titleLength = document.querySelector('[data-value="project-name"] span').textContent.length;
      const observer = new MutationObserver((mutationRecord) => {
        if (titleLength >= maxAllowedChars) {
          INKIVE.C.IS_AUTO_SAVE = false;
          localStorage.setItem('autosave', INKIVE.C.IS_AUTO_SAVE);
          mutationRecord[0].addedNodes[0].querySelector('.context-menu-save').classList.add('disabled');
          mutationRecord[0].addedNodes[0].querySelector('.context-menu-auto-save').classList.add('disabled');
        }
        observer.disconnect();
      });

      observer.observe(document.querySelector('body'), { childList: true });
    },

    canTranslate: function () {
      const translationsComponent = document.querySelector('#translations-panel');

      if (translationsComponent) {
        const section = translationsComponent.querySelector('section');

        if (!section) return;

        const sectionDomRect = section.getBoundingClientRect();
        const translating = sectionDomRect.x >= 0;

        const observer = new MutationObserver((mutationRecord) => {
          if (translating) {
            mutationRecord[0].addedNodes[0].querySelector('.context-menu-translate').classList.add('disabled');
          }
          observer.disconnect();
        });

        observer.observe(document.querySelector('body'), { childList: true });
      }
    },

    hideToolTips: function (event) {
      const $target = $(event.currentTarget);
      const $tooltip = $('body>.tooltip');
      const hideButton = ($target.is('.active') || $target.find('span').is(':visible'));

      $tooltip.css('opacity', hideButton ? 0 : 1);
      hideButton && $tooltip.remove();
    },

    defaultActionEvent: function (event) {
      const action = $(event.currentTarget).data('action');
      const methodName = action + 'Event';

      this[methodName] && this[methodName](event);
    },

    preNameChangeEvent: function (event) {
      const titleContainer = event.currentTarget;
      const numberOfCharacters = event.currentTarget.textContent.length;
      const backButton = document.querySelector('.menus [data-action="exit"]');
      const logo = document.querySelector('header .logo-icon');

      titleContainer.closest('[data-value="project-name"]').classList
        .toggle('error', numberOfCharacters >= maxAllowedChars);
      backButton?.classList?.toggle('disabled', numberOfCharacters >= maxAllowedChars);
      logo.disabled = (numberOfCharacters >= maxAllowedChars);
      logo.classList.toggle('disabled-mouse', numberOfCharacters >= maxAllowedChars);

      if (numberOfCharacters >= maxAllowedChars) {
        event.preventDefault();
        titleContainer.textContent = titleContainer.textContent.substr(0, maxAllowedChars);
        titleContainer.blur();
      } else {
        if (event.key === 'Enter') {
          event.preventDefault();
          titleContainer.blur();
        }
      }
    },

    toggleSelection: function ($el, selectAll) {
      const range = document.createRange();
      range.selectNodeContents($el[0]);
      const sel = window.getSelection();
      sel.removeAllRanges();
      selectAll && sel.addRange(range);
    },

    nameInputBlurEvent: function (event) {
      const $el = this.$el.find('.avoid-shortcuts');
      const isEmpty = !$el.text();
      $el.addClass('expands');

      if (event.target.id === 'svgroot') {
        $el[0].scrollLeft = 0;
      } else {
        event.target.scrollLeft = 0;
      }

      $el.text().length < maxAllowedChars && this.saveProjectName($el);
      // isEmpty || this.saveProjectName($el);
      isEmpty && $el.text(Base64.decode(INKIVE.C.BOOK.name));

      this.toggleSelection($el, false);

      $('#svgroot').off('click', this.nameInputBlurEvent);

      $el.removeClass('focused');
    },

    nameInputClickEvent: function (event) {
      const $el = $(event.currentTarget);
      const newProjectTitles = ['new project', 'new template', 'new design', ''];

      _.includes(newProjectTitles, $el.html().toLowerCase()) && this.toggleSelection($el, true);

      $('#svgroot').one('click', this.nameInputBlurEvent);

      $el.addClass('focused');

      // resets the textbox on click when the user input more than maxAllowedChars/255
      $el.text().length >= maxAllowedChars && $el.empty();
      $el.removeClass('expands');
    },

    undoEvent: function (event) { EditorFacade.handle('history', 'undo'); },
    redoEvent: function (event) { EditorFacade.handle('history', 'redo'); },
    exitEvent: function (event) {
      $(event.currentTarget).removeClass('active');

      if (INKIVE.C.IS_AUTO_SAVE && INKIVE.RestrictionsFactory && !INKIVE.RestrictionsFactory.isAllSaved()) {
        INKIVE.RestrictionsFactory.save();
      }

      EditorFacade.handle('close', {
        confirm_draft: true,
        back_to_create: $(event.currentTarget).is('[data-action=back-create]')
      });
    },

    downloadEvent: function (event) {
      event && event.currentTarget && event.currentTarget.blur();
      UserInfoFactory.canConsume('download').then(
        () => EditorFacade.handle('download', 'display'),
        (response) => this.displayNoActionsLeftError('download', response));
    },

    shareEvent: function (event) {
      const button = event.currentTarget.getBoundingClientRect();
      const width = 420;
      const customDimensions = {
        compact: true,
        width,
        marginTop: 40,
        marginLeft: button.left + button.width - width,
        height: 450
      };
      EditorFacade.handle('page', 'save', { quiet: true }).then(() => {
        UserInfoFactory.canConsume('share', false).then(
          () => EditorFacade.handle('share', 'display', { customDimensions }),
          (response) => this.displayNoActionsLeftError('share', response));
      });
    },

    versionsEvent: function (event) {
      if ($(event.currentTarget).is('.active')) {
        this.versionsView.show();
      }
      $('.ui-dropdown-content[data-id="versions"]').css('right', 'unset');
    },

    resizeEvent: function (event) {
      this.sizeView.showResizeEvent(event);

      if (!this.resizeLoaded) {
        $('.format .antiscroll-wrap').antiscroll({
          autoHide: false
        });
        this.resizeLoaded = true;
      }
    },

    gridEvent: function (event) {
      $(event.currentTarget).is('.active') &&
      this.gridView.show();
    },

    printEvent: function (event) {
      UserInfoFactory.canConsume('print').then(() => {
        let newWindow;
        let blockAttempts = 20;
        const svgCont = this.editor.getSvgString();
        const saveBeforePrint = !INKIVE.Helpers.areEqual(svgCont, INKIVE.EditorFacade.handle('cache', 'get'));

        saveBeforePrint || print();
        saveBeforePrint && EditorFacade.handle('page', 'save').then(print);

        function print () {
          const logo = INKIVE.C.WHITE_LABEL_CONFIGURATION && INKIVE.C.WHITE_LABEL_CONFIGURATION.logo_url;
          newWindow = window.open(
            INKIVE.C.BASE_URL +
            'design/print?id=' +
            INKIVE.C.BOOK.id +
            '&page_number=' +
            INKIVE.Tool._current_page_number +
            (logo ? '&logo=' + logo : '')
          );

          INKIVE.Modal.togglePageLoader(true, 'modal.wait_printing');
          _.delay(checkBlocked, 1000);
        }

        function checkBlocked () {
          if (isWindowBlocked()) {
            blockAttempts--;
            blockAttempts > 0 && _.delay(checkBlocked, 1000);
            blockAttempts > 0 || isBlocked();
          } else {
            waitUntilDone();
          }
        }

        function isBlocked () {
          INKIVE.Modal.togglePageLoader(false, 'modal.wait_printing');
          INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
            message: 'modal.alert.popup_blocker'
          }));
        }

        function waitUntilDone () {
          INKIVE.Modal.togglePageLoader(false, 'modal.wait_printing');
          localStorage.setItem('printing', true);

          $(window).one('storage', function (event) {
            event.originalEvent.key === 'printing' &&
            INKIVE.Modal.togglePageLoader(false, 'modal.wait_printing');
          });
        }

        function isWindowBlocked () {
          try {
            if (typeof newWindow === 'undefined') return true;
            if (newWindow && newWindow.closed) return false;
            if (newWindow && newWindow.tryLoad) return false;

            return true;
          } catch (err) { }

          return false;
        }
      }, (response) => this.displayNoActionsLeftError('print', response));
    },

    orderPrintEvent: function (event) {
      const target = event.currentTarget;
      const isActive = $(target).is('.order-print-shown');
      const orderPopup = $('.ui-dropdown-content[data-id="order-print"]').hide();
      const orderPrintFallback = _.bind(function () {
        this.orderPrintFallbackView || this.loadPrintFallbackView();
        orderPopup.show();
      }, this);

      if (isActive) {
        EditorFacade.handle('printing', 'close');
      } else {
        toggleLoader(true);
        EditorFacade.handle('printing', 'is_project_printable').then((isPrintable) => {
          toggleLoader(false);
          isPrintable ? EditorFacade.handle('printing', 'open') : orderPrintFallback();
        });
      }

      function toggleLoader (show) {
        const $button = $(event.currentTarget).toggleClass('disabled', show);

        INKIVE.Modal[show ? 'loader' : 'loaderClose']($button);
      }

      $('.tool-size div.ui-dropdown-content').is(':visible') && $('.tool-size div.ui-dropdown-content').hide();
    },

    loadPrintFallbackView: function () {
      const OrderPrintFallbackView = require('./contents/order-print-fallback/view');

      this.orderPrintFallbackView = new OrderPrintFallbackView();
    },

    displayNoActionsLeftError: function (type, response) {
      CompanyFactory.getCompany().then(function (company) {
        let key;
        switch (response) {
          case 429:
            key = 'modal.alert.no_actions_for_guest';
            break;
          case 402:
            key = 'modal.alert.no_actions_left';
            break;
          default:
            key = 'common.error';
            break;
        }

        INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
          message: INKIVE.TranslateHelper.translate(key, {
            company_name: company.name
          })
        }));
      });
    },

    initialize: function () {
      // Code for top-submenu (aka top-bar) will be progressively moved to src/views/top-bar
      initTopBar();

      createLayoutButton();

      this.tool = INKIVE.Tool.getInstance();
      this.editor = this.tool.editor;

      _.bindAll(this, 'displayNoActionsLeftError', 'nameInputBlurEvent');

      this.initSubView();
      this.initProjectName();
      this.initTableOfContentsModal();

      INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE && this.$el.children('.options')
        .children('button[data-action="share"]').addClass('hidden');

      INKIVE.C.REVIEW_MODE && this._initReviewButtons();

      History.on('reload', _.bind(this.refreshHistoryUI, this));
      History.on('change', _.bind(this.refreshHistoryUI, this));
      History.on('undo', _.bind(this.refreshHistoryUI, this));
      History.on('redo', _.bind(this.refreshHistoryUI, this));
      EditorFacade.on('project.name.saved', (name) => {
        INKIVE.C.BOOK.name = Base64.encode(name);
        this.$el.find('[data-value="project-name"] span').html(name);
      });

      _.bindAll(this, 'setMenuSize', 'updateCurrentPageInfo');

      ProjectFacade.on('design.removed', this.updateCurrentPageInfo);
      ProjectFacade.on('design.copied', this.updateCurrentPageInfo);
      ProjectFacade.on('design.added', this.updateCurrentPageInfo);
      EditorFacade.on('page.move_to', this.updateCurrentPageInfo);
      DesignFacade.on('template.update.designed', this.updateCurrentPageInfo);

      UserInfoFactory.get().then(() => this._initUpgradeButton());
    },

    updateCurrentPageInfo: function (data) {
      this.sizeView.updateCurrentPageInfo(data);
    },

    initProjectName: function () {
      this.$el.find('[data-value="project-name"] span')
        .text(Base64.decode(INKIVE.C.BOOK.name));

      this.bindedSaveProjectName = _.debounce(_.bind(
        this.saveProjectName, this
      ), 3000);
    },

    saveProjectName: function ($el) {
      const name = $el.text().trim();
      const translate = INKIVE.TranslateHelper.translate;
      const numberOfCharacters = $el.text().length;

      if (numberOfCharacters <= maxAllowedChars) {
        if (name && Base64.decode(INKIVE.C.BOOK.name) !== name) {
          $el.addClass('disabled');
          statusNotification.display(translate('general.saving'), null, true);

          EditorFacade.handle('name_change', {
            name,
            callback: () => {
              statusNotification.display(translate('advice.content.nothing_to_save'));
              $el.removeClass('disabled');
              $('.shr-project h3 span').text(name);
            }
          });
        }
      }
    },

    refreshHistoryUI: function (eventData) {
      const hasPrevious = eventData.history[eventData.current] &&
        typeof eventData.history[eventData.current].parent !== 'undefined';

      const hasNext = eventData.history[eventData.current] &&
        eventData.history[eventData.current].children.length;

      this.$el.find('.menus button[data-action="undo"]').toggleClass('disabled', !hasPrevious);
      this.$el.find('.menus button[data-action="redo"]').toggleClass('disabled', !hasNext);
    },

    setMenuSize: function () {
      if ($('[data-action=order-print]').is('.order-print-shown')) {
        return;
      }
      const widthCorrection = 1;
      const $toolSize = this.$el.children('.tool-size');
      const $pageButtons = $('.pages-button-container');
      const isToolSizeVisible = $toolSize.is(':visible');
      const $resizableContainer = isToolSizeVisible ? $toolSize : this.$el.children('.margin');

      const canvasWidth = $('#canvas-panel').width();
      let marginWidth = $pageButtons.outerWidth();

      if (!marginWidth) marginWidth = -23;
      $resizableContainer.width(canvasWidth - marginWidth + widthCorrection);
      $pageButtons.is(':hidden') && $toolSize.parent().css('padding-left', 0);
    },

    initSubView: function () {
      statusNotification.setElement(this.$el.find('.menus .status'));

      this.versionsView = new VersionsView({
        el: this.$el.find('.ui-dropdown-content[data-id="versions"]')
      });

      this.fileView = new FileView({
        el: this.$el.find('.ui-dropdown-content[data-id="file"]')
      });

      EditorFacade.on('status.update', (opt) => {
        statusNotification.display(opt.msg, opt.timeout, opt.force);
      });

      this.$el.append('<ul class="tool-size"></ul>');
      this.sizeView = new SizeView({
        el: this.$el.find('.tool-size')
      });

      $(window).resize(_.bind(function () {
        setTimeout(() => this.setMenuSize(), 350);
      }, this));

      this.sizeView.on('render', _.bind(function () {
        this.setMenuSize();
        // Enable ruler fo desygner by default
        if (INKIVE.C.MODE.IS_DESYGNER) {
          const tool = INKIVE.Tool.getInstance();

          tool.editor.canvas.runExtensions('enableRuler', {});
        }
      }, this));

      this.setMenuSize();

      // this.gridView = new GridView({
      //   el: this.$el.find('.ui-dropdown-content[data-id="grid"]')
      // });
    },

    initTableOfContentsModal: function () {
      const tableOfContentsTemplate = require('./contents/table-of-contents/template.hbs');
      this.tableOfContentsTemplate = $(tableOfContentsTemplate());
      this.el.querySelector('.menus').appendChild(this.tableOfContentsTemplate[0]);
    },

    _initReviewButtons: function () {
      const container = this.el.querySelector('.options');

      container.querySelectorAll('button').forEach((button) => {
        const isSubmitForReview = button.dataset.action === 'submit-for-review';
        const isFinishLater = button.dataset.action === 'finish-later';

        if (isFinishLater || isSubmitForReview) {
          button.classList.remove('hidden');
          button.addEventListener('click', () => {
            const jobId = decodeURIComponent(document.location.search).split('tasks/')[1];
            const jobPromise = WorkflowFactory.getJobById(jobId);
            const savePromise = EditorFacade.handle('page', 'save');

            Promise.all([jobPromise, savePromise]).then((response) => {
              const job = response[0];

              this.processReviewAction(job, isSubmitForReview);
            });
          });
        } else {
          button.classList.add('hidden');
        }
      });
    },

    processReviewAction: function (job, isSubmitForReview) {
      const saveTranslationsState = async (completed = false) => {
        if (INKIVE.C.TRANSLATION_DATA && job) {
          const output = job.outputs.find(o => o.info.encoded_id === INKIVE.C.BOOK.id);
          const translations = Object.keys(sessionStorage).map((item) => {
            if (item.startsWith('translation:')) {
              const obj = {};
              obj[item] = sessionStorage.getItem(item);

              return obj;
            }

            return false;
          });

          await WorkflowFactory.updateOutputEntity(job, {
            info: {
              ...output.info,
              translations,
              completed
            }
          });
        }

        EditorFacade.handle('close');
      };

      const submitJob = async () => {
        const notCompleted = (output) => !output.info.completed && output.info.encoded_id !== INKIVE.C.BOOK.id;

        if (job) {
          let outputs = job.outputs;

          for (var i = outputs.length - 1; i >= 0; i--) {
              if (outputs[i].output_action === 'fix' && outputs[i].output_type === 'brand_campaign') {
                  outputs.splice(i, 1);
              }
          }

          if (outputs.length === 1 || !outputs.some(output => notCompleted(output))) {
            await WorkflowFactory.patch('jobs', job, 'submitted');
          }
        }

        saveTranslationsState(true);
      };

      if (isSubmitForReview) {
        const translationsCompleted = INKIVE.EditorFacade.handle('translations', 'get_all_completed');

        if (INKIVE.C.TRANSLATION_DATA && !translationsCompleted) {
          const modal = INKIVE.Modal.modalWindow(INKIVE.TranslateHelper.translate('modal.not_all_changes_completed'), {
            width: 600,
            buttons: [{
              title: INKIVE.TranslateHelper.translate('general.yes'),
              onClick: () => {
                submitJob();
                modal.close();
              }
            }, {
              title: INKIVE.TranslateHelper.translate('general.no'),
              onClick: () => {
                saveTranslationsState();
                modal.close();
              }
            }]
          });
        } else {
          submitJob();
        }
      } else {
        saveTranslationsState();
      }
    },

    _initUpgradeButton: async function () {
      const member = await UserInfoFactory.getMembership();
      if (member.is_consumer) return;

      await CompanyFactory.getCompany();

      CompanyFactory.getCompanyData().then((workspace) => {
        const canUpgrade = INKIVE.Helpers.isDesygnerProject()
          ? UserInfoFactory.isProTrialUser() || !UserInfoFactory.isProUser()
          : workspace.is_customisation_preview;
        const workspaceAllowsUpselling = !INKIVE.Helpers.isDesygnerProject() &&
          workspace?.features?.users?.includes('allows_user_upselling') && !UserInfoFactory.hasContentPlan();

        if (canUpgrade || workspaceAllowsUpselling) {
          const plan = getPlan();
          const container = this.el.querySelector('.options');
          const button = document.createElement('button');
          const buttonText = getText();
          const domain = INKIVE.Helpers.isDesygnerProject() ? null : workspace.modal;

          button.classList.add('auto-collapse-upper', 'ui-dropdown-button', 'desygner-clear-button');
          button.innerHTML = `<icon><svg><use xlink:href="#rocket"></use></svg></icon><span>${buttonText}</span>`;
          const attributes = {
            'data-id': 'upgrade',
            'data-popover': 'tooltip',
            'data-placement': 'bottom',
            'data-original-title': buttonText
          };

          Object.entries(attributes).forEach(([key, value]) => {
            button.setAttribute(key, value);
          });

          container.querySelector('[data-value=project-name]').after(button);
          button.addEventListener('click', () => {
            INKIVE.Helpers.displaySubscriptionModal('', plan, !INKIVE.Helpers.isDesygnerProject(), domain);
          });

          $(button).tooltip();
        }

        function getText () {
          let key;
          if (canUpgrade) {
            key = INKIVE.Helpers.isDesygnerProject() ? 'get_pro' : 'get_business';
          } else {
            key = 'chatgpt_more';
          }

          return INKIVE.TranslateHelper.translate(`top_submenu.buttons.${key}`);
        }

        function getPlan () {
          if (workspaceAllowsUpselling) return 'content2';
          return INKIVE.Helpers.isDesygnerProject() ? 'pro' : 'pro_team';
        }
      });
    }
  })));
